import { getStartEndPoint } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/selection';
import { rmSelectedText } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/utils';
// 这个文件代码是从旧版本 editor 中迁移来的，因为新版有用到
export function getParagraphListBySelection(selection, paragraphList) {
    const startEndPoint = getStartEndPoint(selection.anchor, selection.focus);

    const x = paragraphList.reduce((prev, para, index) => {
        if (index < startEndPoint.sIndex || index > startEndPoint.eIndex) return prev;

        if (includeInSelection(para, index, startEndPoint)) {
            return prev.concat({
                ...para,
                para: true,
            });
        }

        // 只有部分，只返回对应的textruns
        return prev.concat({
            ...para,
            ...getSelectedTextruns(para, index, startEndPoint),
            para: false,
        });
    }, []);

    return x;
}

function includeInSelection(para, index, {
    sIndex = 0, eIndex = 0, sOffset = 0, eOffset = 0,
} = {}) {
    if (index > eIndex || index < sIndex) return false;
    if (index < eIndex && index > sIndex) return true;

    const textLength = para.textRuns.reduce((prev, curr) => prev + curr.text?.length || 0, 0);
    if (index === sIndex && index === eIndex) return sOffset === 0 && eOffset === textLength;
    if (index === sIndex) return sOffset === 0;
    if (index === eIndex) return eOffset === textLength;

    return true;
}


function getSelectedTextruns(para, index, {
    sIndex = 0, eIndex = 0, sOffset = 0, eOffset = 0,
} = {}) {
    const textLength = para.textRuns.reduce((prev, curr) => prev + curr.text?.length || 0, 0);
    const s = index === sIndex ? sOffset : 0;
    const e = index === eIndex ? eOffset : textLength;
    const { removedTextRuns } = rmSelectedText(para, s, e);

    return { textRuns: removedTextRuns };
}
